import React, {useEffect, useState} from "react";
import {useLoad} from "../../context";
import ApiServices from "../../services/apiServices";
import "./index.css";

export default function FaqDeslogado() {
  const {load, setLoad} = useLoad();
  const [faq, setFaq] = useState([]);
  async function fnFaq() {
    try {
      setLoad(true);
      let response = await ApiServices.apiGet("faq/de-visitante");
      setFaq(response.data);
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  useEffect(() => {
    fnFaq();
  }, []); //eslint-disable-line react-hooks/exhaustive-deps
  

  return (
    <>
      <div className="d-flex justify-content-center m-5">
        <div style={{width:900}}>
          {faq.map((e, i) => !e.logado &&(
            <div key={i} className="accordion accordion-flush" id={"accordionFlushExample" + i}>
              <div className="accordion-item">
                <h2 className="accordion-header" id={"flush-headingOne" + i}>
                  <button
                    className="accordion-button collapsed tituloFaq"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={"#flush-collapseOne" + i}
                    aria-expanded="false"
                    aria-controls="flush-collapseOne">
                    {e.titulo}
                  </button>
                </h2>
                <div
                  id={"flush-collapseOne" + i}
                  className="accordion-collapse collapse textFaq"
                  aria-labelledby={"flush-headingOne" + i}
                  data-bs-parent={"#accordionFlushExample" + i}>
                  <div className="accordion-body faqDeslogado" dangerouslySetInnerHTML={{__html: e.texto}} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
